// various DOM nodes get data-* props to enable scrolling
const PM_MARK_ID_ATTR = 'data-addition-id'
const PM_MARK_DEL_ID_ATTR = 'data-deletion-id'
const PM_MARK_STATUS_ATTR = 'data-status'

const CHANGE_DATA_ATTRIBUTE = {
  PM_MARK_ID_ATTR,
  PM_MARK_DEL_ID_ATTR,
  PM_MARK_STATUS_ATTR,
} as const

type ChangeAttribute = ValueOf<typeof CHANGE_DATA_ATTRIBUTE>

// build a queryselector like `[data-addition-id~="abc123"]
// see https://developer.mozilla.org/en-US/docs/Web/CSS/Attribute_selectors#attrvalue_2
const idSelector = (attribute: ChangeAttribute, id: string) =>
  `[${attribute}~="${id}"]`

export const findChangeMark = (
  threadId: string,
  isAddition: boolean,
): HTMLElement | null => {
  // we could skip this cartwheel if the two selectors started with the same substring
  const rawSelector = isAddition ? PM_MARK_ID_ATTR : PM_MARK_DEL_ID_ATTR
  const selector = idSelector(rawSelector, threadId)
  const node = document.querySelector(selector)
  return node instanceof HTMLElement ? node : null
}
